import React from 'react';
import './Steps.css';

const Certifications = ({ formData, setFormData, language = 'fr' }) => {
  const t = {
    title: language === 'fr' ? 'Certifications' : 'Certifications',
    description: language === 'fr' 
      ? 'Ajoutez vos certifications et formations complémentaires'
      : 'Add your certifications and additional training',
    itemTitle: (i) => language === 'fr' ? `Certification ${i + 1}` : `Certification ${i + 1}`,
    nameLabel: language === 'fr' ? 'Nom de la certification *' : 'Certification Name *',
    namePlaceholder: language === 'fr' 
      ? 'Certification React - The Bridge'
      : 'React Certification - The Bridge',
    issuerLabel: language === 'fr' ? 'Organisme *' : 'Issuer *',
    issuerPlaceholder: language === 'fr' ? '9antra.tn' : '9antra.tn',
    dateLabel: language === 'fr' ? 'Date *' : 'Date *',
    datePlaceholder: language === 'fr' ? 'Juillet 2024' : 'July 2024',
    removeBtn: language === 'fr' ? 'Supprimer' : 'Remove',
    addBtn: language === 'fr' ? '+ Ajouter une certification' : '+ Add Certification'
  };

  const handleCertificationChange = (index, field, value) => {
    const newCertifications = [...formData.certifications];
    newCertifications[index][field] = value;
    setFormData(prev => ({ ...prev, certifications: newCertifications }));
  };

  const addCertification = () => {
    setFormData(prev => ({
      ...prev,
      certifications: [...prev.certifications, { name: '', issuer: '', date: '' }]
    }));
  };

  const removeCertification = (index) => {
    const newCertifications = formData.certifications.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, certifications: newCertifications }));
  };

  return (
    <div className="step-content">
      <h2>{t.title}</h2>
      <p className="step-description">{t.description}</p>

      {formData.certifications.map((cert, index) => (
        <div key={index} className="form-item">
          <div className="item-header">
            <h3>{t.itemTitle(index)}</h3>
            <button type="button" className="remove-btn" onClick={() => removeCertification(index)}>
              {t.removeBtn}
            </button>
          </div>

          <div className="form-grid">
            <div className="input-group full-width">
              <label>{t.nameLabel}</label>
              <input
                type="text"
                value={cert.name}
                onChange={(e) => handleCertificationChange(index, 'name', e.target.value)}
                placeholder={t.namePlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.issuerLabel}</label>
              <input
                type="text"
                value={cert.issuer}
                onChange={(e) => handleCertificationChange(index, 'issuer', e.target.value)}
                placeholder={t.issuerPlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.dateLabel}</label>
              <input
                type="text"
                value={cert.date}
                onChange={(e) => handleCertificationChange(index, 'date', e.target.value)}
                placeholder={t.datePlaceholder}
                required
              />
            </div>
          </div>
        </div>
      ))}

      <button type="button" className="add-btn" onClick={addCertification}>
        {t.addBtn}
      </button>
    </div>
  );
};

export default Certifications;